import React from "react";
import { motion } from "framer-motion";

const GoogleReviews = () => {
  const reviews = [
    {
      text: "W Manufakturze Formy ćwiczę od ponad 3 miesięcy. Polecam to miejsce ze względu na profesjonalizm trenerów, którzy motywują a zarazem tworzą dobrą atmosferę. Stroje do ćwiczeń są zawsze czyste i pachnące. Wszędzie jest czysto. Obsługa bardzo rzeczowa.",
      rating: 5,
      userName: "Anna",
    },
    {
      text: "Polecam to miejsce. Profesjonalne podejście, doświadczeni trenerzy, miła i sprawna obsługa. Klaudia, Justyna i Wiktor są super. Treningi dostosowane do kondycji i możliwości, suche kombinezony przyjemne w użytkowaniu i zawsze czyste.",
      rating: 5,
      userName: "Marek",
    },
    {
      text: "Miejsce naprawdę godne polecenia. Ćwiczę od końcówki września. Niespożyta energia i zapał trenerów, przemiła obsługa i świetne warunki powodują, że przestać ćwiczyć nie zamierzam.",
      rating: 5,
      userName: "Kasia",
    },
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className="text-yellow-500">
        {index < rating ? "★" : "☆"}
      </span>
    ));
  };

  return (
    <section className="bg-white text-black py-10 px-5">
      <div className="max-w-7xl mx-auto text-center mb-10">
        <h2 className="text-3xl font-bold mb-5">Opinie Naszych Klientów</h2>
      </div>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {reviews.map((review, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            className="bg-white rounded-lg shadow-lg p-5 text-center"
          >
            <p className="text-gray-600 italic">"{review.text}"</p>
            <div className="mt-2">{renderStars(review.rating)}</div>
            <p className="mt-2 font-semibold">{review.userName}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default GoogleReviews;
